import { JOURNEY_TYPES, ONBOARDING_FLOW_SCREENS, ONB_REDIRECTION_STATUS } from "core/constants";
import { getIsDomain915 } from "src/utils/config/domainConfig";
import { ROUTES } from "../constants/routes";
import { clearNomineeReturnToExplore, getNomineeReturnToExplore } from "../storage";

export const useRedirectToPreviousPage = (source: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  const journeyType = searchParams.get('journeyType');
  const callbackRedirection = searchParams.get('callbackRedirection');
  const isDomain915 = getIsDomain915();

  const goBackToPreviousPage = () => {
    if (isDomain915) {
      if (source === ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN) {
        window.location.href = ROUTES.TERMIAL_LAYOUT;
      }
      return;
    }

    if (window.location.pathname === ROUTES.FNO_ONBOARDING) {
      const redirectUrl = isDomain915 ? ROUTES.TERMIAL_LAYOUT : ROUTES.FNO_EXPLORE_PAGE;
      window.location.href = redirectUrl;
      return;
    }

    switch (journeyType) {
      case JOURNEY_TYPES.DDPI:
        if (callbackRedirection && source === ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN) {
          window.location.href = `${callbackRedirection}?esignStatus=${ONB_REDIRECTION_STATUS.SUCCESS}`;
        } else if (callbackRedirection && source === ONBOARDING_FLOW_SCREENS.FAILURE) {
          window.location.href = `${callbackRedirection}?esignStatus=${ONB_REDIRECTION_STATUS.FAILED}`;
        } else if (callbackRedirection && (source === 'BACK_POPUP' || source === ONBOARDING_FLOW_SCREENS.ONBOARDING_PENDING_SCREEN)
        ) {
          window.location.href = `${callbackRedirection}`;
        } else {
          window.location.href = ROUTES.GROWW_HOME_PAGE;
        }
        break;


      case JOURNEY_TYPES.MF_NOMINEE_EDIT:
        window.location.href = ROUTES.MF_EXPLORE_PAGE;
        break;

      case JOURNEY_TYPES.ALL_INVESTMENTS_ADD:
        // Return to homepage post onboarding journey nominee addition else redirect to profile page
        if (getNomineeReturnToExplore()) {
          clearNomineeReturnToExplore();
          window.location.href = ROUTES.GROWW_HOME_PAGE;
        } else {
          window.location.href = ROUTES.PROFILE_PAGE;
        }
        break;

      case JOURNEY_TYPES.FNO_INCOME_PROOF_DOC_UPLOAD:
        window.location.href = ROUTES.FNO_ONBOARDING;
        break;

      case JOURNEY_TYPES.HUF_ONBOARDING:
        window.location.href = ROUTES.GROWW_HOME_PAGE;
        break;

      case JOURNEY_TYPES.MAIN_ONBOARDING:
        window.location.href = ROUTES.GROWW_HOME_PAGE;
        break;

      case JOURNEY_TYPES.DEMAT_CLOSURE:
        window.location.href = ROUTES.GROWW_HOME_PAGE;
        break;

      default:
        window.location.href = ROUTES.PROFILE_PAGE;

    }
  }

  return {
    callbackRedirection,
    goBackToPreviousPage
  }
};
